// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".b.b--icon[data-v-0e52bc3e]{padding:.25rem;box-shadow:none}.b.b--icon[data-v-0e52bc3e],.b.b--icon[data-v-0e52bc3e]>*{width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
